import { i18n } from '@/i18n'
export default {
  state: {
    rules: {
      isRequired: (v, e) =>
        !!v.replaceAll(' ', '') ||
        (typeof e !== 'undefined'
          ? e
          : i18n.t('interface.errors.requiredField')),
      isCorrectEmail: (v, e) =>
        /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,6})$/.test(v) ||
        (typeof e !== 'undefined' ? e : i18n.t('interface.errors.wrongEmail')),
      isCorrectPhone: (v, e) =>
        v.replace(/\D/g, '').length >= 9 ||
        (typeof e !== 'undefined' ? e : i18n.t('interface.errors.wrongPhone')),
      onlyLatin: (v, e) =>
        /^[A-Za-z\s]*$/.test(v) ||
        (typeof e !== 'undefined' ? e : 'Только латинские буквы'),
      onlyLetters: (v, e) =>
        /^[A-Za-zА-Яа-яёЁ\s]*$/.test(v) ||
        (typeof e !== 'undefined' ? e : 'Без цифр и символов'),
      noSymbols: (v, e) =>
        /^[A-Za-z0-9\s]*$/.test(v) ||
        (typeof e !== 'undefined' ? e : 'Только латинские буквы и цифры'),
      latinOrCyrilic: (v) =>
        !(/[^а-яА-яёЁ\s]/.test(v) && /[^a-zA-Z\s]/.test(v)) ||
        'Только кириллица или только латиница',
      digitsReq: (v, e) => /^(?=.*?[0-9])/.test(v) || e,
      minLength: (v, e, l = 8) => (!!v && v.length >= l) || e,
      minLength2: (v, e, l = 2) =>
        !v || (!!v && v.length >= l) || 'Не менее 2 символов',
      maxLength: (v, e, l = 8) => v.length <= l || e,
      notEqual: (v1, v2, e) => v1 === v2 || e,
      aliquot: (v, e, l = 100) =>
        !!v & (v % l === 0) || 'Введите сумму кратную 100',
      moreThan: (v, e, l = 200) =>
        !!v & (v >= l) || 'Минимальный порог 200 коинов',
      lessThan: (v, e, l = 1000) => !!v & (v <= l) || 'Не более 1000 коинов',
    },
  },
  getters: {
    Rules(state) {
      return state.rules
    },
  },
}
